import pathOr from 'ramda/es/pathOr';
import actions from './actions';

const initialState = {};

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.API_SET_PATH: {
      const path = action.payload.value || {};
      return Object.assign({}, state, {
        _config: {
          ...state._config,
          apiPath: path
        }
      });
    }
    case actions.API_SET_WIDGETID: {
      const widgetId = action.payload.value || '';
      return Object.assign({}, state, {
        _config: {
          ...state._config,
          widgetId
        }
      });
    }
    case actions.API_SET_SKILL_RECOMMENDATION_API_PATH: {
      const path = action.payload.value || '';
      return Object.assign({}, state, {
        _config: {
          ...state._config,
          skillRecommendationApiPath: path
        }
      });
    }
    case actions.API_ACTION_STARTED:
    case actions.API_ACTION_SUCCEEDED:
    case actions.API_ACTION_FAILED: {
      const {key, error, response, retainOldValues} = action.payload;
      const defaultData = retainOldValues
        ? pathOr(null, [key, 'data'], state)
        : null;
      const newState = Object.assign({}, state, {
        [key]: {
          loading: action.type === actions.API_ACTION_STARTED,
          error: action.type === actions.API_ACTION_FAILED ? error : null,
          data:
            action.type === actions.API_ACTION_SUCCEEDED
              ? response.data
              : defaultData
        }
      });
      return newState;
    }
    case actions.API_PATCH_DATA: {
      const {key, value} = action.payload;
      return Object.assign({}, state, {
        [key]: {
          ...state[key],
          data: Object.assign({}, state[key]?.data, value)
        }
      });
    }
    case actions.API_CLEAR_DATA: {
      const {key} = action;
      const newState = {...state};
      delete newState[key];
      return newState;
    }
    case actions.API_SET_LOADING: {
      const {key} = action.payload;
      const newState = Object.assign({}, state, {
        [key]: {
          loading: true
        }
      });
      return newState;
    }
    default:
      return state;
  }
};

export default apiReducer;
